import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/riders/disciplines', { params })
  },
  store (formData) {
    return apiClient.post('/riders/disciplines', formData)
  },
  show (id, params) {
    return apiClient.get(`/riders/disciplines/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/riders/disciplines/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/riders/disciplines/${id}`)
  }
}
